'use client';

import { c as _c } from "react/compiler-runtime";
import { useSession } from '@/lib/auth-client';
import { SignInEmailStart } from './SignInEmailStart';
import { Flame } from 'lucide-react';
interface SignInEmailBannerProps {
  heading?: string;
  subtext?: string;
  buttonLabel?: string;
  className?: string;
  variant?: 'warm' | 'dark';
}
export function SignInEmailBanner(t0) {
  const $ = _c(23);
  const {
    heading: t1,
    subtext,
    buttonLabel,
    className,
    variant: t2
  } = t0;
  const heading = t1 === undefined ? "Sign up for early preview" : t1;
  const variant = t2 === undefined ? "warm" : t2;
  const {
    data: session,
    isPending
  } = useSession();
  if (session?.user || isPending) {
    return null;
  }
  const isWarm = variant === "warm";
  const t3 = isWarm ? "mx-auto max-w-2xl rounded-2xl border border-orange-200 bg-gradient-to-r from-orange-50 via-amber-50 to-orange-50 px-6 py-6 sm:px-8 sm:py-8" : "mx-auto max-w-2xl rounded-2xl bg-gray-800 px-6 py-6 sm:px-8 sm:py-8";
  const t4 = isWarm ? "h-5 w-5 text-orange-500" : "h-5 w-5 text-primary-400";
  let t5;
  if ($[0] !== t4) {
    t5 = <Flame className={t4} />;
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = isWarm ? "text-lg font-bold text-gray-900" : "text-lg font-bold text-white";
  let t7;
  if ($[2] !== heading || $[3] !== t6) {
    t7 = <h3 className={t6}>{heading}</h3>;
    $[2] = heading;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t5 || $[6] !== t7) {
    t8 = <div className="mb-2 flex items-center justify-center gap-2">{t5}{t7}</div>;
    $[5] = t5;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = isWarm ? "text-sm text-gray-600" : "text-sm text-gray-400";
  let t10;
  if ($[8] !== subtext || $[9] !== t9) {
    t10 = <p className={t9}>{subtext}</p>;
    $[8] = subtext;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t8) {
    t11 = <div className="mb-4 text-center">{t8}{t10}</div>;
    $[11] = t10;
    $[12] = t8;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== buttonLabel) {
    t12 = <SignInEmailStart buttonLabel={buttonLabel} className="mx-auto max-w-lg" />;
    $[14] = buttonLabel;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== t12 || $[18] !== t3) {
    t13 = <div className="container mx-auto px-4 sm:px-6 lg:px-8"><div className={t3}>{t11}{t12}</div></div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t3;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== className || $[21] !== t13) {
    t14 = <div className={className}>{t13}</div>;
    $[20] = className;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
}